import { LabelWithExternalVendorIcons } from 'components/LabelWithExternalVendorIcons/LabelWithExternalVendorIcons'
import type { TPointExternalVendorNames } from 'utils/getPointExternalVendorNames'

const DEVICE_VENDOR_ICON_SIZE = 20

export const DashboardDeviceLabel = ({
  name,
  externalVendorNames,
}: {
  name: string
  externalVendorNames: TPointExternalVendorNames | undefined
}) => (
  <LabelWithExternalVendorIcons
    label={name}
    externalVendorNames={externalVendorNames}
    iconSize={DEVICE_VENDOR_ICON_SIZE}
  />
)
